import { Controller } from "@hotwired/stimulus"

// General-purpose controller: hide a target element when a source field's value
// matches a given value. Use for select/input-driven conditional visibility.
//
// Usage:
//   data-controller="conditional-visibility"
//   data-conditional-visibility-hide-when-value="Some value"
//   data-conditional-visibility-source-target="source"  (on the input/select)
//   data-conditional-visibility-target="target"         (on the element to show/hide)
export default class extends Controller {
  static targets = ["source", "target"]
  static values = { hideWhen: String }

  connect() {
    this.updateVisibility()
  }

  toggle() {
    this.updateVisibility()
  }

  updateVisibility() {
    if (!this.hasSourceTarget || !this.hasTargetTarget) return

    const value = (this.sourceTarget.value || "").trim()
    const isEmpty = !value
    const matchesHideWhen = this.hideWhenValue && value === this.hideWhenValue
    const shouldHide = isEmpty || matchesHideWhen
    this.targetTarget.style.display = shouldHide ? "none" : ""
  }
}
